export const PaymentDocumentInvoiceConstant = {
    DOCUMENT_CODE: 'DOCUMENT',
    INVOICE_CODE: 'INVOICE',
    INDIVIDUAL_RECEIVER: 'INDIVIDUAL',
    ORGANISATION_RECEIVER: 'ORGANISATION',
    CREDITNOTE_CODE: 'CREDITNOTE'
}

export const select2WithoutSearchOption = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}

export const select2LocationOption = {
    placeholder: "",
    allowClear: true,
    width: 'auto',
    dropdownAutoWidth: true,
    minimumInputLength: 3,
    focus: true,
}

export const select2Country = {
    placeholder: "",
    allowClear: true,
    width: 'auto',
    dropdownAutoWidth: true,
    minimumInputLength: 0,
    ajax: null
}